export const MARKER_TYPE_PHOTOSPHERE = "PHOTOSPHERE";
export const MARKER_TYPE_PRODUCT = "PRODUCT";
export const MARKER_TYPE_NORTH = "NORTH";
export const MARKER_TYPE_PROMO = "PROMOTION";
